import { Col, Divider, Row } from "antd";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FieldBuilder from "../../form-components/field-builder";
import { useContext, useEffect, useState } from "react";
import { IArea } from "../../../models/area/response";
import EndPoints from "../../../services/end-points";
import AppContext from "../../../context/app/context";

export const UserConditionsSection = ({ control }) => {
    const { t } = useTranslation();
    const [area, setArea] = useState<IArea[]>([]);
    const [areaLoading, setAreaLoading] = useState(true);
    const { direction } = useContext(AppContext);


    useEffect(() => {
        const getAreas = async () => {
            try {
                const { data } = await EndPoints.discountarea.getAllAreas({
                    light: true,
                    perPage: -1,
                });
                setArea(data.data);
                setAreaLoading(false);
            } catch (error) {
            } finally {
                setAreaLoading(false);
            }
        };
        if (enableArea)
            getAreas();
    }, [direction]);
    const enableAgeRange = useWatch({ control, name: "enableAgeRange" });
    const enableArea = useWatch({ control, name: "enableArea" });
    const enableGender = useWatch({ control, name: "enableGender" });
    const enableNumberOfOrders = useWatch({ control, name: "enableNumberOfOrders" });
    const enableDaysSinceLastCompletedOrder = useWatch({ control, name: "enableDaysSinceLastCompletedOrder" });
    const byInvitation = useWatch({
        control,
        name: "isInvitation",
    });
    const orderLimitType = useWatch({ control, name: "orderLimitType" });
    const daysLimitType = useWatch({ control, name: "daysLimitType" });
    return (
        <>
            <Divider orientation="center">{t("user_conditions")}</Divider>
            <Row gutter={[16, 8]}>
                {!byInvitation && enableArea && <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
                    <FieldBuilder
                        name="areaId"
                        label={`${t("area")}`}
                        width="large"
                        rules={{ required: enableArea }}
                        disabled={byInvitation}
                        input={{
                            type: "select",
                            loading: areaLoading,
                            allowSearch: true,
                            options: area?.map((area, index) => ({
                                key: index,
                                label: area.name,
                                value: area.id,
                            })),
                        }}
                    />
                </Col>}
                {!byInvitation && enableGender && <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
                    <FieldBuilder
                        name="gender"
                        label={t("gender")}
                        width="large"
                        rules={{ required: enableGender }}
                        disabled={byInvitation}
                        input={{
                            type: "select",
                            loading: false,
                            options: [
                                { label: t("male"), value: 1 },
                                { label: t("female"), value: 2 },
                            ],
                        }}
                    />
                </Col>}

                {enableAgeRange && (
                    <>
                        <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
                            <FieldBuilder
                                name="minAge"
                                label={t("min_age")}
                                input={{ type: "number" }}
                                rules={{ required: enableAgeRange }}
                            />
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
                            <FieldBuilder
                                name="maxAge"
                                label={t("max_age")}
                                input={{ type: "number" }}
                                rules={{ required: enableAgeRange }}
                            />
                        </Col>
                    </>
                )}
                {!byInvitation && enableNumberOfOrders && (
                    <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
                        <FieldBuilder
                            name="orderLimitType"
                            label={t("order_limit_type")}
                            rules={{ required: enableNumberOfOrders }}
                            input={{
                                type: "select",
                                loading: false,
                                options: [
                                    { label: t("set_min_orders"), value: "min" },
                                    { label: t("set_max_orders"), value: "max" },
                                    { label: t("set_range_orders"), value: "range" },
                                    { label: t("set_exact_orders"), value: "exact" },
                                ],
                            }}
                        />
                    </Col>
                )}

                {!byInvitation && enableNumberOfOrders && (orderLimitType === "min" || orderLimitType === "range") && (
                    <Col xs={24} sm={12}>
                        <FieldBuilder
                            name="minNumberOfOrders"
                            label={t("min_number_of_orders")}
                            input={{ type: "number" }}
                            rules={{ required: !byInvitation && enableNumberOfOrders && (orderLimitType === "min" || orderLimitType === "range") }}
                        />
                    </Col>
                )}

                {!byInvitation && enableNumberOfOrders && (orderLimitType === "max" || orderLimitType === "range") && (
                    <Col xs={24} sm={12}>
                        <FieldBuilder
                            name="maxNumberOfOrders"
                            label={t("max_number_of_orders")}
                            input={{ type: "number" }}
                            rules={{ required: !byInvitation && enableNumberOfOrders && (orderLimitType === "max" || orderLimitType === "range") }}
                        />
                    </Col>
                )}

                {!byInvitation && enableNumberOfOrders && orderLimitType === "exact" && (
                    <Col xs={24} sm={12}>
                        <FieldBuilder
                            name="exactNumberOfOrders"
                            label={t("exact_number_of_orders")}
                            input={{ type: "number" }}
                            rules={{ required: !byInvitation && enableNumberOfOrders && orderLimitType === "exact" }}
                        />
                    </Col>
                )}

                {!byInvitation && enableDaysSinceLastCompletedOrder && (
                    <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
                        <FieldBuilder
                            name="daysLimitType"
                            label={t("days_since_last_completed_order_limit_type")}
                            rules={{ required: enableDaysSinceLastCompletedOrder }}
                            input={{
                                type: "select",
                                loading: false,
                                options: [
                                    { label: t("set_min_days_since_last_completed_order"), value: "min" },
                                    { label: t("set_max_days_since_last_completed_order"), value: "max" },
                                    { label: t("set_range_days_since_last_completed_order"), value: "range" },
                                    { label: t("set_exact_days_since_last_completed_order"), value: "exact" },
                                ],
                            }}
                        />
                    </Col>
                )}

                {!byInvitation && enableDaysSinceLastCompletedOrder && (daysLimitType === "min" || daysLimitType === "range") && (
                    <Col xs={24} sm={12}>
                        <FieldBuilder
                            name="minDaysSinceLastCompletedOrder"
                            label={t("min_days_since_last_completed_order")}
                            input={{ type: "number" }}
                            rules={{ required: !byInvitation && enableDaysSinceLastCompletedOrder && (daysLimitType === "min" || daysLimitType === "range") }}
                        />
                    </Col>
                )}

                {!byInvitation && enableDaysSinceLastCompletedOrder && (daysLimitType === "max" || daysLimitType === "range") && (
                    <Col xs={24} sm={12}>
                        <FieldBuilder
                            name="maxDaysSinceLastCompletedOrder"
                            label={t("max_days_since_last_completed_order")}
                            input={{ type: "number" }}
                            rules={{ required: !byInvitation && enableDaysSinceLastCompletedOrder && (daysLimitType === "max" || daysLimitType === "range") }}
                        />
                    </Col>
                )}

                {!byInvitation && enableDaysSinceLastCompletedOrder && daysLimitType === "exact" && (
                    <Col xs={24} sm={12}>
                        <FieldBuilder
                            name="exactDaysSinceLastCompletedOrder"
                            label={t("exact_days_since_last_completed_order")}
                            input={{ type: "number" }}
                            rules={{ required: !byInvitation && enableDaysSinceLastCompletedOrder && daysLimitType === "exact" }}
                        />
                    </Col>
                )}
            </Row>
        </>
    );
};